module.exports = __webpack_public_path__ + "img/album05_01.d049d728.jpg";